<template>
    <div>
        <div class="ibox-title ibox-grey">
            <h4>{{ __("price_lists_assigned_to_the_customer") }}</h4>
            <slot name="help"></slot>
        </div>

        <div class="ibox-content" data-cy="client-prices-list-box">
            <a
                href="#"
                class="btn btn-primary m-b"
                data-cy="client-prices-list-btn"
                @click.prevent="openAddPriceListToClientModal()"
                v-if="mode != 'preview'"
            >
                <i class="fa fa-plus"></i> {{ __("add_price_list") }}
            </a>

            <div class="scroll-table">
                <div class="table-responsive text-nowrap">
                    <price-lists-table
                        data-cy="client-prices-list-table"
                        :priceLists="priceLists"
                        :previewRoute="previewRoute"
                        :mode="mode"
                        :currentRoute="currentRoute"
                        :inNewWindow="inNewWindow"
                    />
                </div>
            </div>

            <div class="row">
                <div
                    class="col-md-12"
                    :class="hasError('priceLists') ? 'has-error' : ''"
                >
                    <span
                        class="help-block text-danger"
                        v-if="hasError('priceLists')"
                    >
                        {{ getError("priceLists") }}
                    </span>
                </div>
            </div>
        </div>

        <modal-add-price-list-to-client
            ref="price_list_to_client_modal"
            id="price_list_to_client_modal"
            :title="__('add_price_list')"
            :mode="mode"
        />
    </div>
</template>

<script>
import ModalAddPriceListToClient from "./../../components/modals/ModalAddPriceListToClient";
import PriceListsTable from "./../../components/tables/client/PriceListsTable";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        ModalAddPriceListToClient,
        PriceListsTable
    },
    props: ["client", "priceListsInit", "previewRoute", "currentRoute", "mode", "inNewWindow", "oldPriceList"],
    computed: {
        ...mapGetters({
            priceLists: "getPriceLists",
            errors: "getErrors",
            old: "getOld"
        })
    },
    methods: {
        openAddPriceListToClientModal() {
            this.$refs.price_list_to_client_modal.openModal();
        },
        hasError(inputName) {
            return this.errors[inputName] != undefined;
        },
        getError(inputName) {
            return this.errors[inputName] != undefined
                ? this.errors[inputName][0]
                : [];
        },
        ...mapActions([
            "saveClientId",
            "addToPriceLists",
            "addToPriceListsByIds"
        ])
    },
    mounted() {
        if (this.old.priceLists != undefined) {
            this.addToPriceListsByIds(this.old.priceLists);
        }
        else if(this.priceListsInit != undefined) {
            this.addToPriceLists(this.priceListsInit);
        }
        else if(this.oldPriceList != undefined && this.oldPriceList !== "[]"){
            this.addToPriceListsByIds(JSON.parse(this.oldPriceList).priceLists);
        }

        if (this.client != undefined) {
            this.saveClientId(this.client * 1);
        }
    }
};
</script>
